import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { ConditionsMultipleChoice } from '../../../../questiontype/MultipleChoice/registry/ConditionsMultipleChoice';
import { ConditionsOrderedChoice } from '../../../../questiontype/OrderedChoice/registry/ConditionsOrderedChoice';
import { ConditionsChoice } from '../../../../questiontype/Choice/registry/ConditionsChoice';
import { ConditionsMultiSelect } from '../../../../questiontype/MultiSelect/registry/ConditionsMultiSelect';
export class ConditionRegistryQuestionTypes extends ConditionRegistryCategory {
    label = 'Fragetyp spezifisch';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_c = new ConditionsChoice(this);
    c_mc = new ConditionsMultipleChoice(this);
    c_o = new ConditionsOrderedChoice(this);
    c_s = new ConditionsMultiSelect(this);
}
